'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const getAirportInfo = require( './getAirportInfo' );
const { object, string, array } = propTypes;
const createReactClass = require('create-react-class');

const MoreInfo = createReactClass({
  propTypes: {
    id: string,
    functionParams: array,
    pageData: object
  },

  getMoreInfo( ) {
    const { pageData: { pageName, productClass } } = this.props;
    const location = getAirportInfo( pageName );
    const path = productClass === 'CP' ? 'parking/' : 'hotels/';
    if ( !location || !location.code ) return false;
    const feedPath = 'moreInfo/' + path + location.code + '.json';
    try {
      return require( '../../../../config/exports/' + feedPath );
    } catch ( e ) {
      //console.log( e );
      return false;
    }
  },

  render() {
    const { id, functionParams } = this.props;
    const moreInfo = this.getMoreInfo( );

    if ( !moreInfo ) return ( <span id={ id } /> );
    return (
      <div id={ id }>
        { moreInfo.moreInfoText.length > 0 && (
          <div>
            <h3>{ functionParams[0] } Articles</h3>
            { moreInfo.moreInfoText.map( ( item, key ) => {
              return (
                <p key={ key }>
                  <a href={ '/' + item.pageName + '.html' } title={ item.pageTitle }>{ item.pageTitle.split( ' - ' )[0] }</a>
                  <br />
                  { item.description }
                </p>
              );
            })}
          </div>
        )}
        { moreInfo.moreInfo.length > 0 && (
          <div>
            <h3>{ functionParams[0] }</h3>
            <ul className="unstyled">
              { moreInfo.moreInfo.map( ( item, key ) => {
                return (
                  <li key={ key }>
                    <a href={ '/' + item.pageName + '.html' } title={ item.pageTitle }>{ item.pageTitle.split( ' - ' )[0] }</a>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  }
});

module.exports = MoreInfo;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/moreInfo.jsx